export const personas = {
  leisure: "leisure",
  corporate: "corporate",
  vacation: "vacation",
};
